import { useForm } from "react-hook-form";
import { ReportPutType } from "../../types/Report";
import { ErrorMessage } from "@hookform/error-message";
import {
  IconAlignBoxLeftTopFilled,
  IconCheck,
  IconUpload,
} from "@tabler/icons-react";
import TextArea from "../core/TextArea";
import { REQUIERED } from "../../const/ValidationHints";
import Input from "../core/Input";
import { putReport, useReport } from "../../fetch/fetch.report.ts";
import { EMPTY_REPORT } from "../../const/typeDefault/ReportDefault.ts";
import LoadingInput from "../core/loading/LoadingInput.tsx";
import ErrMessage from "../core/ErrMessage.tsx";
import { useSubmitState } from "../../hooks/useSubmitState.ts";
import { ERROR_TEXT, ErrorType } from "../../types/Error/Errors.ts";
import { ERROR_ICON } from "../../types/Error/ErrorIcons.tsx";
import { LOADING_CIRCLE } from "../core/loading/LoadingCircle.tsx";

const initButton = (
  <>
    <IconUpload />
    Veröffentlichen
  </>
);
const loadingButton = (
  <>
    {LOADING_CIRCLE}
    Veröffentliche Anzeige
  </>
);
const successButton = (
  <>
    <IconCheck />
    Anzeige veröffentlicht
  </>
);

const errorButton = (error: ErrorType) => {
  return (
    <>
      {ERROR_ICON[error]}
      {ERROR_TEXT[error]}
    </>
  );
};

const ReportResponseForm = ({ reportId }: { reportId: string }) => {
  const { report, isLoading, isError } = useReport(reportId, EMPTY_REPORT);
  const {
    handleSubmit,
    formState: { errors, touchedFields },
    register,
  } = useForm<ReportPutType>({
    defaultValues: {
      _id: reportId,
      response: report.response,
    },
    mode: "all",
  });
  const { init, fetchFailed, fetchSuccess, buttonChild } = useSubmitState({
    initButtonChild: initButton,
  });
  if (isLoading) return <LoadingInput />;
  if (isError) return <ErrMessage message={isError.message} />;

  const handlePut = async (data: ReportPutType): Promise<void> => {
    init(loadingButton);
    const postRes = await putReport(data);
    if (!postRes.ok) {
      fetchFailed(postRes.error, errorButton(postRes.error));
      return;
    }
    fetchSuccess(successButton);
  };

  return (
    <form
      onSubmit={handleSubmit(handlePut)}
      className="flex flex-col gap-2 justify-stretch"
    >
      <Input
        input="textarea"
        validatorHint={<ErrorMessage errors={errors} name="response" />}
        icon={<IconAlignBoxLeftTopFilled stroke={2} />}
        label="Antwort"
        isTouched={!!touchedFields.response}
        isError={!!errors.response}
      >
        <TextArea
          placeholder="Beschreibe dein Anliegen."
          fieldKey={"response"}
          register={register}
          registerOptions={{ required: { value: true, message: REQUIERED } }}
        />
      </Input>
      <button className={`btn btn-primary w-full`}>{buttonChild}</button>
    </form>
  );
};
export default ReportResponseForm;
